import * as React from 'react';
import * as _ from 'lodash';
import CheckBox from './../PageLayout/CheckBox';
import misc from './../../misc.js';
import BlueDropDown from './../PageLayout/DropDowns/BlueDropDown';
import { subscriptionPeriodMapper } from './purchaseReducer';
export default function () {
    function onChecked1(purchase, g, p, pIndex, e) {
        this.props.selectSubscriptionGroup(p.groupName);
    }
    function onItemClick2(purchase, g, p, pIndex, subscription) {
        this.props.selectSubscription(p.groupName, subscription);
    }
    function repeatP3(purchase, g, p, pIndex) {
        return React.createElement('div', {
            'className': 'pm-block ' + p.className,
            'key': p.groupName
        }, React.createElement('div', { 'className': 'pm-text' }, React.createElement('h3', { 'className': 'pm-title' }, 'Purchase ', p.title), React.createElement('span', { 'className': 'pm-price' }, '$', p.selectedSubscription.price.toFixed(2), ' PER ', subscriptionPeriodMapper(p.selectedSubscription.period).toUpperCase()), React.createElement('p', { 'className': 'pm-description' }, '\r\n          ', p.description, '\r\n        '), React.createElement(CheckBox, {
            'text': 'PURCHASE LEAD PROGRAM',
            'checked': p.groupName === purchase.selectedSubscriptionGroup,
            'onChecked': onChecked1.bind(this, purchase, g, p, pIndex)
        }), p.groupName !== 'pay-per-lead' ? React.createElement(BlueDropDown, {
            'items': p.subscriptions,
            'style': {
                textAlign: 'left',
                width: '100%',
                marginLeft: '30px',
                marginTop: '10px'
            },
            'selectedItem': p.selectedSubscription,
            'onItemClick': onItemClick2.bind(this, purchase, g, p, pIndex),
            'itemKey': this.subscriptionKey,
            'itemValue': this.subscriptionValue,
            'key': '1220'
        }) : null));
    }
    function onClick4(purchase, g) {
        this.props.goToNextStep();
    }
    function scopePurchaseG5() {
        var purchase = this.props.purchase;
        var g = purchase.selectedSubscriptionGroupRef;
        return React.createElement('div', { 'className': 'paper' }, React.createElement('div', { 'className': 'logo' }), React.createElement.apply(this, [
            'div',
            { 'className': 'pm' },
            purchase.isModal ? React.createElement('button', {
                'className': 'pm-close',
                'key': '515'
            }) : null,
            _.map(purchase.subscriptionsGroups, repeatP3.bind(this, purchase, g)),
            React.createElement('div', { 'className': 'pm-footer text-right' }, purchase.selectedSubscription ? React.createElement('button', {
                'className': 'ui-button5 ui-button5--green',
                'onClick': onClick4.bind(this, purchase, g),
                'key': '1742'
            }, React.createElement('span', { 'className': 'ui-button-continue' }, 'CONTINUE')) : null)
        ]));
    }
    return scopePurchaseG5.apply(this, []);
}